const BASE_URL = ''; // keep as requested

// =====================
// INVOICE
// =====================
export async function generatePDF(invoiceData) {
  try {
    const response = await fetch(`${BASE_URL}api/generate-invoice`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(invoiceData),
    });

    if (!response.ok) throw new Error('Error generating PDF');
    return await response.blob();
  } catch (error) {
    throw new Error(`Error generating PDF: ${error.message}`);
  }
}

// =====================
// DRIVERS
// =====================
export async function getDrivers(carrierId) {
  const res = await fetch(`${BASE_URL}api/drivers?carrierId=${carrierId}`);
  if (!res.ok) throw new Error('Failed to fetch drivers');
  return res.json();
}

export async function addDriver(name, carrierId) {
  const res = await fetch(`${BASE_URL}api/drivers`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, carrierId }),
  });
  if (!res.ok) throw new Error('Failed to add driver');
  return res.json();
}

export async function deleteDriver(id, carrierId) {
  const res = await fetch(`${BASE_URL}api/drivers/${id}?carrierId=${carrierId}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error('Failed to delete driver');
  return res.json();
}

// =====================
// BROKERS (Shared)
// =====================
export async function getBrokers() {
  const res = await fetch(`${BASE_URL}api/brokers`);
  if (!res.ok) throw new Error('Failed to fetch brokers');
  return res.json();
}

export async function addBroker(name) {
  const res = await fetch(`${BASE_URL}api/brokers`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
  if (!res.ok) throw new Error('Failed to add broker');
  return res.json();
}

export async function deleteBroker(id) {
  const res = await fetch(`${BASE_URL}api/brokers/${id}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error('Failed to delete broker');
  return res.json();
}

// =====================
// 1099 Payout Totals
// =====================
export async function getPayoutTotals({ carrierId, year, month }) {
  const url = new URL(`${BASE_URL}api/payouts/totals`, window.location.origin);
  url.searchParams.set('carrierId', carrierId);
  if (year) url.searchParams.set('year', year);
  if (month) url.searchParams.set('month', month);

  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to fetch payout totals');
  return res.json();
}
